import { useEffect, useState } from 'react';
import { setCoordinate, setNoCoordinates } from '@/models/user';

export const getGeolocationErrorMessage = (error: GeolocationPositionError) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      return 'Пользователь запретил доступ к геолокации.';
    case error.POSITION_UNAVAILABLE:
      return 'Информация о местоположении недоступна.';
    case error.TIMEOUT:
      return 'Время ожидания геолокации истекло.';
    default:
      return error.message || 'Не удалось определить местоположение.';
  }
};

export const useGeolocation = (enabled = true) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    if (!navigator.geolocation) {
      setError('Геолокация не поддерживается устройством.');
      setLoading(false);
      return;
    }

    let active = true;

    const handleSuccess: PositionCallback = ({ coords }) => {
      if (active) {
        setCoordinate({ latitude: coords.latitude, longitude: coords.longitude });
        setNoCoordinates(false);
        setError(null);
        setLoading(false);
      }
    };

    const handleError: PositionErrorCallback = (positionError) => {
      if (active) {
        setError(getGeolocationErrorMessage(positionError));
        setLoading(false);
      }
    };

    const requestAccuratePosition = () => {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 120000,
      });
    };

    navigator.geolocation.getCurrentPosition(
      handleSuccess,
      (positionError) => {
        if (!active) return;
        if (positionError.code === positionError.PERMISSION_DENIED) {
          handleError(positionError);
          return;
        }
        requestAccuratePosition();
      },
      { enableHighAccuracy: false, timeout: 5000, maximumAge: 120000 },
    );

    return () => {
      active = false;
    };
  }, [enabled]);

  return { loading, error };
};
